export class AddressDetails {
  id = "";
  address1 = "";
  address2 = "";
  city = "";
  state = "";
  country = "";
  zipCode = "";
}
